// ENG-3676 (PR 2): opening records from the toolbar and the row caret menu. Behind
// title_opens_side_panel: RecordsHOC passes recordOpenActions only with the flag on.

import { opensMessageDrawerOnClick } from './inboxRowCapabilities';
import { distinctDocuments } from './recordRowIdentity';

// Opening more than this many tabs at once is more likely a mis-click than a plan.
export const MAX_NEW_TABS = 10;

// A record with a document to show. A reply row whose click opens message history
// keeps that as its only way in, as it does for the title.
export const isOpenableRecord = (record) => Boolean(
  record && record !== 'all' && record.file_token && !opensMessageDrawerOnClick(record),
);

// The documents a selection can open, one per document: on Referrals, checking a row
// also checks the other rows of its document, which must not open twice.
export const openableDocuments = (records) => distinctDocuments(records.filter(isOpenableRecord));

// Whether the toolbar shows its Open buttons: the flag is on (recordOpenActions is
// passed) and the selection has something to open.
export const showsOpenActions = (records, recordOpenActions) => Boolean(
  recordOpenActions && openableDocuments(records).length > 0,
);

// Opens each path in its own tab and returns the paths the browser blocked. Browsers
// allow one new tab per click until the user allows pop-ups for the site;
// window.open returns null for each blocked tab. `noopener` is set on the opened
// window instead of in the features string, because with it window.open always
// returns null and every tab would look blocked.
export const openPathsInNewTabs = (paths) => {
  const blocked = [];
  paths.forEach((path) => {
    const opened = window.open(path, '_blank');
    if (opened) {
      opened.opener = null;
    } else {
      blocked.push(path);
    }
  });
  return blocked;
};
